
import { Component, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { AxiosResponse } from "axios";
import api from "@/network/api";
import { Route } from "vue-router";
import { eventBus } from "../../eventBus";

@Component
export default class AppBottomNavBar extends Vue {
  @Getter("isAuthenticated") private isAuthurized!: boolean;
  @Getter("userManualEnabled") private userManualEnabled!: boolean;
  @Getter("userHelpButtonEnabled") private userHelpButtonEnabled!: boolean;
  notifications: any = [];
  @Getter("eventId") private eventId!: number;
  created() {
    if (this.isAuthurized) {
      this.loadNotifications();
      this.$store.dispatch("fetchSystemSettings");
    }
    this.createSubscribtion();

    eventBus.$on("reloadNotifications", this.loadNotifications);
  }
  @Watch("eventId")
  createSubscribtion() {
    if (this.isAuthurized && this.eventId != 0) {
      this.$socket.client.on(
        "evenue_database_NewNotification." + this.eventId,
        (payload: any) => {
          let index: any = -1;
          this.notifications.forEach(function(obj: any, id: any) {
            if (obj.id == payload.notification.id) {
              index = id;
            }
          });
          if (index == -1) {
            this.notifications.push(payload.notification);
          } else {
            this.notifications.splice(index, 1, payload.notification);
          }
        }
      );

      this.$socket.client.on(
        "evenue_database_DeleteNotification." +
          this.eventId,
        (payload: any) => {
          if (this.notifications.length > 0) {
            let index = -1;
            this.notifications.forEach(function(obj: any, id: number) {
              if (obj.id == payload.notification.id) {
                index = id;
              }
            });
            if (index >= 0) {
              this.notifications.splice(index, 1);
            }
          }
        }
      );
    }
  }

  loadNotifications() {
    api.get("notifications").then((res: AxiosResponse) => {
      this.notifications = res.data.notifications;
    });
  }
  beforeDestroy() {
    this.$socket.client.off(
      "evenue_database_NewNotification." + this.eventId
    );
    this.$socket.client.off(
      "evenue_database_DeleteNotification." + this.eventId
    );

    eventBus.$off("reloadNotifications", this.loadNotifications);
  }

  unread(notifications: any) {
    return Vue.filter("unread")(notifications);
  }
}
